import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ContactHero from './components/ContactHero';
import ContactForm from './components/ContactForm';
import EmergencyBanner from './components/EmergencyBanner';

const ContactPage = () => {
  useEffect(() => {
    document.title = 'Contact NS Electrical WA | Get a Quote | Perth Commercial Electrician';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <ContactHero />
        <ContactForm />
        <EmergencyBanner />
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;